// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1BQx0","label":"styles_label__1ENou"};